<div class="help-dialog">
  <sync-dialog
    [config]="{
      title: 'Get help',
      isClosable: true,
    }"
    [isFullScreen]="false"
    [open]="openHelpDialog"
    [onClose]="closeHelpDialog"
  >
    <div class="help-dialog-container">
      <p>
        Visit the
        <a (click)="mpSyncKnowledgebase()" [href]="helpLinks.HElP_CENTER" target="_blank">Sync Help Center</a> for the
        latest tutorials, setup guides, and details about Sync features.
      </p>

      <sync-list [ListItems]="helpCategories"></sync-list>
    </div>

    <span class="contact-support-button"
      >Still can't find what you're looking for?
      <sync-button
        [type]="'flat'"
        [label]="'Contact Support'"
        [size]="'small'"
        [onClick]="onContactSupportClick"
      ></sync-button>
    </span>
  </sync-dialog>
</div>

<div class="contact-support-dialog">
  <sync-dialog
    [config]="
      isSupportSent
        ? {
            isClosable: false,
            title: 'Contact support',
          }
        : {
            isClosable: true,
            title: 'Contact support',
            actionButton: 'Send',
            cancelButton: 'Cancel',
            onActionClick: sendSupportTicket,
            onCancelClick: onCancelSupportClick,
          }
    "
    [open]="viewContactSupport"
    [onClose]="cleanupSupportState"
  >
    <div class="contact-support-container">
      <div class="sub-container">
        <span class="body-1"
          >Can't find the answer in our <a [href]="helpLinks.KNOWLEDGE_BASE" target="_blank">knowledge base</a>?</span
        >
        <span class="body-1">Send a message to our Support Team.</span>
      </div>
      <div class="alert-container">
        <sync-alert
          *ngIf="submitted && supportForm?.invalid"
          [type]="'critical'"
          [leadIcon]="'info'"
          [showLeadIcon]="true"
          [title]="'Correct the errors in the form below, then try again.'"
          [showCloseButton]="false"
          [showActions]="false"
          [description]="''"
          [showPrimaryAction]="false"
        ></sync-alert>
        <app-error [errcode]="errcode"></app-error>
      </div>
      <form *ngIf="supportForm" [formGroup]="supportForm">
        <sync-text-field
          [label]="'Name'"
          [value]="supportForm.get('name')?.value"
          [readOnly]="true"
          formControlName="name"
        >
        </sync-text-field>

        <sync-text-field
          [label]="'Email'"
          [value]="user.email"
          [readOnly]="true"
          [caption]="true"
          [captionHint]="'Responses will be sent to this email address.'"
          formControlName="email"
        >
        </sync-text-field>

        <sync-text-field [label]="'Subject'" [errorMessage]="getFieldError('subject')" formControlName="subject">
        </sync-text-field>

        <div class="text-area">
          <sync-textarea
            [label]="'Description'"
            [rows]="6"
            [errorMessage]="getFieldError('description')"
            formControlName="description"
          >
          </sync-textarea>
        </div>

        <sync-checkbox
          [label]="'Attach error logs to this message'"
          [checked]="supportForm?.get?.('attachLogs')?.value"
          [indeterminate]="false"
          [disabled]="false"
          formControlName="attachLogs"
        >
        </sync-checkbox>
      </form>
    </div>
  </sync-dialog>
</div>
